import { render } from "./Contact.vue?vue&type=template&id=0a9039e8&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0a9039e8"

export default script